import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Languages, Themes } from '@/shared/api/model';
import type { DashboardPreset } from '@/pages/home/dashboard-config';

export type MenuMode = 'side' | 'top';

interface UserPreferencesState {
    language: Languages;
    theme: Themes;
    menuMode: MenuMode;
    dashboardPreset: DashboardPreset;
    favoriteHomeLinks: string[];
    setLanguage: (language: Languages) => void;
    setTheme: (theme: Themes) => void;
    setMenuMode: (menuMode: MenuMode) => void;
    setDashboardPreset: (dashboardPreset: DashboardPreset) => void;
    setFavoriteHomeLinks: (favoriteHomeLinks: string[]) => void;
}

export const useUserPreferencesStore = create<UserPreferencesState>()(
    persist(
        (set) => ({
            language: Languages.EN,
            theme: Themes.LIGHT,
            menuMode: 'side',
            dashboardPreset: 'operations_overview',
            favoriteHomeLinks: ['/customer-management', '/loans/applications', '/loans/repayment'],
            setLanguage: (language) => set({ language }),
            setTheme: (theme) => set({ theme }),
            setMenuMode: (menuMode) => set({ menuMode }),
            setDashboardPreset: (dashboardPreset) => set({ dashboardPreset }),
            setFavoriteHomeLinks: (favoriteHomeLinks) => set({ favoriteHomeLinks }),
        }),
        {
            name: 'user-preferences-storage',
        }
    )
);
